<div class="contextual-parameters">
  @for (param of parameterNames(); track param) {
    <mat-icon class="param-icon">settings</mat-icon>
    <span class="param-name">{{ param }}</span>
    <span class="badge-and-description">
      <glxy-badge [color]="'blue'" size="small" class="auto-badge">
        {{ 'AI_ASSISTANT.SETTINGS.CONTEXTUAL_PARAMETERS.AUTO' | translate }}
      </glxy-badge>
      <span class="param-description">
        {{ 'AI_ASSISTANT.SETTINGS.CONTEXTUAL_PARAMETERS.AUTO_FETCHED' | translate }}
      </span>
      <mat-icon class="info-icon" matTooltip="{{ 'AI_ASSISTANT.SETTINGS.CONTEXTUAL_PARAMETERS.TOOLTIP' | translate }}">
        info
      </mat-icon>
    </span>
  }
</div>
